export const BeneficiaryType = Object.freeze({
    "Primary": 1,
    "Contingent": 2,
    "Contingent2": 3
})